import { render, staticRenderFns } from "./wenli.vue?vue&type=template&id=0b7b8f86&"
import script from "./wenli.vue?vue&type=script&lang=js&"
export * from "./wenli.vue?vue&type=script&lang=js&"
import style0 from "./wenli.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports